export function validateLoginEmail(email: string): boolean {
  // valid cases: X@X.X X@X.X.X
  return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(\.+[a-zA-Z0-9-]+)+$/.test(email);
}
